
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *  2025-04-09 (1.0.0) (jhoward)
 *    - <menu-item-price> handles displaying prices for dining menu items.
 */

import {defineComponent} from 'vue';

interface PerPersonRegExpExecArray extends RegExpExecArray {
  groups?: {
    price?: string;
  };
}

export default defineComponent({
  name: "MenuItemPrice",
  props: {
    priceToDisplay: {
      type: String,
      required: true
    },
    priceLabel: {
      type: String,
      default: ''
    },
    ariaPrefix: {
      type: String,
      default: ''
    },
    ariaSuffix: {
      type: String,
      default: ''
    },
  },
  computed: {
    isPriceAriaHidden(): boolean {
      return !!this.priceLabel.length;
    },
  },
})
